var map = {
	"./Alumni.gif": 4267,
	"./Alumni1.gif": 1035,
	"./CASE Philanthropic Benchmarking.gif": 7140,
	"./CASE Philanthropic Benchmarking1.gif": 8270,
	"./Donor Insights.gif": 4603,
	"./Donor Insights1.gif": 9367,
	"./Fundraising Performance Overview.gif": 6802,
	"./Fundraising Performance Overview1.gif": 6009,
	"./Gifts in Wills.gif": 5639,
	"./Gifts in Wills1.gif": 8113,
	"./Major Giving.gif": 4326,
	"./Major Giving1.gif": 8840,
	"./Single Giving and Appeals.gif": 6400,
	"./Supporter Trends.gif": 3957,
	"./Supporter Trends1.gif": 9075,
	"./dashboardheader.gif": 5996
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3821;